import { render, staticRenderFns } from "./検査２.vue?vue&type=template&id=7296e63c&scoped=true&"
import script from "./検査２.vue?vue&type=script&lang=js&"
export * from "./検査２.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7296e63c",
  null
  
)

export default component.exports